// funkcija vraca inicijale za user avatar
export const getInitials = (_user) => {
  const user = _user || localStorage.korisnik;
  if (user) {
    const nameArray = user.split(' ');
    const initials = nameArray.map((word) => word.charAt(0)).join('');
    return initials;
  }
  return '';
};
